import { Box, Button, Dialog as MUIDialog, styled, TextField } from '@mui/material';

import { theme } from 'styles';

export const Dialog = styled(MUIDialog)(() => ({
  '.MuiDialog-paper': {
    width: '556px',
    padding: '16px',
    borderRadius: '12px',
    boxShadow: '0px 8px 32px rgba(0,0,0,0.12)',
    background: theme.palette.white.main,
  },
  '.MuiBackdrop-root': {
    background: 'rgba(0,0,0,0.2)',
    backdropFilter: 'blur(4px)',
  },
}));

export const StyledTextField = styled(TextField)(() => ({
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    background: theme.palette.white.main,
    fontSize: '14px',
    height: '44px',
    border: `1px solid ${theme.palette.primary.grey}`,
    boxShadow: 'none',
    '&.Mui-focused': { border: `1px solid ${theme.palette.info.main}` },
  },
  '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
  '& .MuiInputBase-input': {
    padding: '0 12px',
    fontSize: '14px',
  },
  '& .MuiInputBase-input::placeholder': {
    fontSize: '14px',
    color: theme.palette.primary.grey,
  },
}));

export const FooterActions = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '12px',
  marginTop: '24px',
}));

export const CancelButton = styled(Button)(() => ({
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '14px',
  borderRadius: '8px',
  padding: '10px 24px',
  color: theme.palette.secondary.dark,
  border: `1px solid ${theme.palette.primary.grey}`,
  background: theme.palette.white.main,
}));

export const DuplicateButton = styled(Button)(() => ({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  borderRadius: '8px',
  padding: '10px 24px',
  color: theme.palette.white.main,
  background: theme.palette.info.main,
  border: 'none',
}));
